var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSleepPods = function SvgSleepPods(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 21.2 13.2"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M8.6 12.6h-8v-1m8 1h12v-1m-12 1v-1m0 0v-5a1 1 0 0 1 1-1h7a4 4 0 0 1 4 4m-12 2h-8m8 0h12m-20 0v-7a4 4 0 0 1 4-4h12a4 4 0 0 1 4 4v5m0 0v2m-15-4a1 1 0 1 1-2 0 1 1 0 0 1 2 0"
  })));
};
export default SvgSleepPods;